import { useEffect, useState } from 'react';
import { useEvent, useLocalStorage } from 'react-use';

export const useThemeInfo = () => {
  const [paypalTheme, setPaypalTheme] = useState(false);

  const [enabled] = useLocalStorage('ppui-theme', document.body.classList.contains('theme-ppui')) || '';

  const triggerEvent = (key: { target: { className: any; }; }) => {
    const triggerEventElement = key?.target?.className;
    if (
      triggerEventElement !== undefined &&
      triggerEventElement !== '' &&
      triggerEventElement === 'theme-enable-option'
    ) {
      const theme = localStorage.getItem('ppui-theme');
      setPaypalTheme(theme === '"true"');
    }
  };
  useEvent('click', triggerEvent);

  useEffect(() => {
    setPaypalTheme(localStorage.getItem('ppui-theme') === '"true"');
  }, [enabled]);

  return { paypalTheme, enabled };
};
